import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import * as inspectReq from '../../../redux/appointmentForm/requests/inspection-req';
import withCareUserSubtitle from '../hocs/withCareUserSubtitle';
import {
  selectProgressCareUser,
  selectProgressServicesByVisit,
} from '../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  services: selectProgressServicesByVisit(state),
  careUser: selectProgressCareUser(state),
});

const mapDispatchToProps = {
  setService: appointmentProgressActions.setService,
  inspectAll: inspectReq.actions.send,
};

export const enhance = compose(
  injectIntl,
  withCareUserSubtitle,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentServices/enhance.js